import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";

const JoinContext = React.createContext({
  state: { menuList: [] },
  actions: {
    joinContest: () => { },
  },
});


const JoinProvider = ({ children }) => {
  const [menuList, setMenuList] = useState({});



  //메뉴 생성
  const joinContest = useCallback(async (team) => {
    console.log("joinContest: ", team)
    HttpAction({
      url: "member/contest/join",
      method: "post",
      data: {
        contestId: team.contestId,
        contestTeamMemberList: team.contestTeamMemberList,
        email: team.email,
        name: team.name,
        phoneNumber: team.phoneNumber,
        teamName: team.teamName,
        institueName: team.institueName,
        grade: team.grade,
        major: team.major,
      }
    }).then((res) => {
      if (res.code === 200) {
        alert("챌린지 신청에 성공했습니다.");
      } else {
        alert(res.message);
        //alert("메뉴 생성에 실패했습니다.");
      }
    });
  }, []);



  const value = {
    state: { menuList },
    actions: { joinContest },
  };

  return <JoinContext.Provider value={value}>{children}</JoinContext.Provider>;

};

const { Consumer: JoinConsumer } = JoinContext;

export { JoinProvider, JoinConsumer, JoinContext };

export default JoinContext;


